import React from 'react'
import {Link} from "react-router-dom";
import {IoIosArrowForward} from 'react-icons/io'
const InfoList=({list})=>{

    function buildList(list) {
        const getDetailLink=({id,infoType,...it})=>{
            const page=infoType==='info'?'detail':'pdetail';
            return `/${page}/${id}`;
        }
        return list.map(it=>(
            <li key={it.id}>
                <Link to={getDetailLink(it)} >
                    {it.title}
                </Link>
                <IoIosArrowForward color='gray' />
            </li>
        ))
    }
    return (
        <ul className='list-unstyled list-wrap'>
            {list&& list.length>0 && buildList(list)}
        </ul>
    )
}
export default  InfoList;